<template>
  <template-item layout="flex" label="生成的行/列">
    <el-select
      v-model="value"
      clearable
      multiple
      size="mini"
      style="padding: 0 5px;"
    >
      <el-option
        v-for="it in dataSource"
        :key="`options-${it.id}`"
        :label="it.name"
        :value="it.id"
      >
      </el-option>
    </el-select>
  </template-item>
</template>
<script>
import { Select, Option } from "element-ui";
import TemplateItem from "@/components/excel/designer/template/TemplateItem";

export default {
  name: "sequence-province-selector",
  components: {
    TemplateItem,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    dataSource: {
      type: Array,
    },
  },
  data() {
    return {
      value: [],
    };
  },
  methods: {},
};
</script>
